<template>
  <section id="lab-user-account" class="all-cases-view">
    <div class="container-small-table">
      <div class="listings-navbar">
        <ul class="d-flex flex-wrap justify-content-end list-items-group-15">
          <li>
            <div class="form-element input-with-icon search-input-lg">
              <el-input
                v-model="search_string"
                @input="getAutoCompleteUsersData"
                placeholder="Search"
                :clearable="true"
              ></el-input>
              <span>
                <img
                  src="@/assets/images/icons/search-icon-with-bg-red.svg"
                  alt="icon"
                  class="img-fluid icon"
                />
              </span>
            </div>
          </li>
        </ul>
      </div>
      <!-- Web version -->

      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="allUserAccounts.data"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            @sort-change="onChangeSort"
            ref="multipleTable"
          >
            <el-table-column
              label="User"
              fixed
              width="300"
              prop="first_name"
              sortable="custom"
            >
              <template #defualt="scope"
                >{{ scope.row.first_name }} {{ scope.row.last_name }}</template
              >
            </el-table-column>

            <el-table-column label="Role" prop="user_type" sortable="custom">
              <template #default="scope">
                {{ userTypeMap[scope.row.user_type] }}
              </template>
            </el-table-column>
            <el-table-column
              label="Username"
              min-width="200"
              prop="username"
              sortable="custom"
            >
              <template #defualt="scope">{{ scope.row.username }}</template>
            </el-table-column>
            <el-table-column
              label="Status"
              prop="status"
              width="200"
              sortable="custom"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeStatus(command, scope.row._id, scope.$index)
                    "
                    trigger="click"
                  >
                    <span class="el-dropdown-link cursor">
                      <el-tag :type="getStatusType(scope.row.status)">{{
                        scope.row.status.split("_").join(" ")
                      }}</el-tag>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="status-dropdown-menu">
                        <el-dropdown-item
                          v-if="scope.row.status !== 'INACTIVE'"
                          command="INACTIVE"
                          >INACTIVE</el-dropdown-item
                        >
                        <el-dropdown-item
                          v-if="scope.row.status !== 'ACTIVE'"
                          command="ACTIVE"
                          >ACTIVE</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="140">
              <template #default="scope">
                <ul class="listings__action-buttons">
                  <li>
                    <el-button @click="onView(scope.row)" class="view-button">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button @click="onPasswordReset(scope.row)">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/reset-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/reset-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li>
                    <el-button
                      @click="onDeleteUser(scope.row._id)"
                      class="delete-button"
                    >
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/delete-active.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/delete-deactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination
            v-model:currentPage="page"
            v-model:page-size="pageSize"
            :page-sizes="[10, 25, 50, 100]"
            layout=" prev, pager, next, jumper, sizes ,total"
            :total="allUserAccounts.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import { userSearchOptions } from "@/config/constants/searchConstants";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper, FilterHelper],

  computed: {
    ...mapGetters("userAccounts", [
      "getAllUserAccounts",
      "getUserAccountStatusUpdated",
      "getUserAccountErrors",
      "getUserAccountDeleteStatus",
      "getUserPasswordResetStatus",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    paginationProps() {
      return {
        pageSizes: this.pageSizes || [10, 15, 25],
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "success";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "default";
        }
      };
    },
    isSearchByInput() {
      return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.checkUserTypeAndFetchData();
    this.$store.dispatch("userAccounts/refreshErrors");
  },
  data() {
    return {
      searchOptions: userSearchOptions,
      searchByKey: ["user", "username", "role"],
      searchBy: "",
      search_string: "",
      page: 1,
      loading: false,
      allUserAccounts: {},
      search: "",
      userTypeMap: {
        ADMIN: "Admin",
        LAB_ADMIN: "Lab Admin",
        LAB_MANAGER: "Lab Manager",
        LAB_DATA_ASSISTANT: "Lab Assistant",
        BILLING_REPRESENTATIVE: "Billing Representative",
        HOSPITAL_PHYSICIAN: "Physician",
        HOSPITAL_ADMIN: "Hospital Admin",
        HOSPITAL_ACCOUNT_MANAGER: "Account Manager",
        LAB_DATA_ADMIN:"Lab Data Admin",
        QC_MANAGER:"QC Manager",
        AR_LEAD: "AR-Lead",
        AR_EXECUTIVE: "AR-Excutive",
        CP_LEAD: "CP-Lead",
        CODING_LEAD: "Coding-Lead",
        CODING_EXECUTIVE: "Coding-Excutive",
        POSTING_EXECUTIVE: "Posting-Excutive",
        SR_FTE: "Senior-FTE",
      },
      physician: "",
      hospital: "",
      userType: "",
      pageSize: 25,
      orderBy: "",
      orderType: "",
    };
  },

  methods: {
    clearInputSearch() {
      this.search_string = "";

      this.isSearchByInput = "";
      this.page = 1;
      this.fetchAllUserAccounts(this.page);
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedUserPage
        ? parseInt(this.$route.query.selectedUserPage)
        : 1;
      this.pageSize = this.$route.query.selectedUserPageSize
        ? parseInt(this.$route.query.selectedUserPageSize)
        : 25;
      if (this.$route.query.selectedUserOrderBy) {
        this.orderBy = this.$route.query.selectedUserOrderBy;
      }
      if (this.$route.query.selectedUserOrderType) {
        this.orderType = this.$route.query.selectedUserOrderType;
      }
      if (this.$route.query.selectedLabUserString) {
        this.search_string = this.$route.query.selectedLabUserString;
      }
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedUserPage: params.page,
        selectedLabUserString: params.search_string,
        selectedUserPageSize: params.limit,
        selectedUserOrderBy: params.order_by,
        selectedUserOrderType: params.order_type,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchAllUserAccounts(this.page);
    },
    onCurrentPageChange(pageNo) {
      this.fetchAllUserAccounts(pageNo);
    },
    clearUsersSearch() {
      this.search_string = "";
      this.previousSearchString = "";
      this.page = 1;
      this.fetchAllUserAccounts(1);
    },
    async checkUserTypeAndFetchData() {
      if (this.isHospitalAdmin()) {
        // method from mixin
        this.hospital = this.currentUserHospital;
      }
      await this.fetchAllUserAccounts(1);
    },
    async fetchAllHospitals() {
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
    },
    async fetchAllUserAccounts() {
      try {
        this.loading = true;
        let params = {
          page: this.page,
          limit: this.pageSize,
          lab: this.$route.params.lab_id,
        };

        if (this.search_string) {
          params.search_string = this.search_string;
        }

        if (this.physician) {
          params.physician = this.physician;
        }
        if (this.hospital) {
          params.hospital = this.hospital;
        }
        if (this.userType) {
          params.user_type = this.userType;
        }

        if (this.orderBy && this.orderType) {
          params.order_by = this.orderBy;
          params.order_type = this.orderType;
        }
        await this.$store.dispatch("userAccounts/fetchLabUserAccounts", params);
        this.updateQueryParams(params);
        this.allUserAccounts = JSON.parse(
          JSON.stringify(this.getAllUserAccounts)
        );
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },
    goToAddUserAccount() {
      return this.$router.push({
        name: "AddLabUsers",
        params: {
          lab_id: this.$route.params.lab_id,
        },
      });
    },

    async getAutoCompleteUsersData() {
      // to eleminate empty search strings
      setTimeout(() => {
        this.page = 1;
        this.fetchAllUserAccounts(this.page);
      }, 600);
    },
    editUserAccount(userId) {
      return this.$router.push({
        name: "EditLabUser",
        params: {
          user_id: userId,
          lab_id: this.$route.params.lab_id,
        },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },

    onView(user) {
      this.editUserAccount(user._id);
    },
    onDeleteUser(userId) {
      this.$confirm("Are you sure want to DELETE User. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        await this.deleteUser(userId);
      });
    },

    async deleteUser(userId) {
      await this.$store.dispatch("userAccounts/deleteUserAccount", {
        id: userId,
      });
      if (this.getUserAccountDeleteStatus) {
        successNotification("User deleted successfully");

        this.fetchAllUserAccounts(1);
      } else {
        errorNotification("Error at deleting user");
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllUserAccounts(this.page);
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAllUserAccounts(this.page);
    },
    async loadData(data) {
      if (data) {
        if (data.pageSize != this.pageSize) {
          data.page = 1;
        }

        if (
          data.sort &&
          data.sort.prop &&
          data.sort.order &&
          this.orderBy !== data.sort.prop
        ) {
          data.page = 1;
        }
        this.pageSize = data.pageSize;
        this.orderBy = data.sort && data.sort.prop ? data.sort.prop : "";

        this.orderType =
          data.sort && data.sort.order
            ? data.sort.order == "ascending"
              ? "ASC"
              : "DESC"
            : "";
        if (data.type !== "init") {
          await this.fetchAllUserAccounts(data.page);
        }
      }
    },

    async changeStatus(command, id, index) {
      let params = {
        status: command,
        id: id,
      };
      await this.$store.dispatch(
        "userAccounts/updateUserAccountStatus",
        params,
        {
          root: true,
        }
      );
      if (this.getUserAccountStatusUpdated) {
        this.$notify({
          type: "success",
          title: "Success",
          message: "User status updatd successfully",
        });
        this.allUserAccounts.data[index].status = command;
      } else if (
        this.getUserAccountErrors &&
        this.getUserAccountErrors.critical_error
      ) {
        this.$notify({
          type: "error",
          title: "Error",
          message: this.getUserAccountErrors.critical_error,
        });
      } else {
        this.$notify({
          type: "error",
          title: "Error",
          message: "Error at updating user status",
        });
      }
    },

    searchByUserType() {
      this.fetchAllUserAccounts(1);
    },
    async fetchAllPhysiciansByHospital(hospitalId) {
      this.physician = null;
      let params = {
        get_all: true,
      };
      if (hospitalId) {
        params.hospital = hospitalId;
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      } else {
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      }

      this.fetchAllUserAccounts(1);
    },

    onPasswordReset(user) {
      let userId = user._id;
      let userName = user.first_name + " " + user.last_name;

      this.$confirm(
        `Are you sure want to  Reset <b>${
          userName || "User"
        }</b> 's Password. Continue ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.resetPassword(userId);
      });
    },
    async resetPassword(id) {
      try {
        let params = {
          id,
        };
        await this.$store.dispatch(
          "userAccounts/resetUserAccountPassword",
          params
        );
        if (this.getUserPasswordResetStatus) {
          this.$alert(
            "User Password reset Successfully! <br>User will recieve Email with new password !",
            "Success",
            {
              confirmButtonText: "OK",
              dangerouslyUseHTMLString: true,
            }
          );
        } else if (this.getUserAccountErrors) {
          this.$notify.error({
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#user-account {
  max-width: 1200px;
  margin: 0 auto;
  .inner-navbar {
    ul {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      li {
        &:not(:last-child) {
          margin-right: 1em;
        }
        .add-btn {
          padding: 9px 15px;
          background: #6f52ed;
          border-radius: 3px;
          color: #fff;
          border: none;
          font-weight: 500;
          text-transform: uppercase;
          img {
            margin-right: 10px;
            margin-bottom: -3px;
          }
        }
      }
    }
    .el-select {
      max-width: auto;
      background: transparent;
    }
  }
  .content {
    margin-top: 20px;
    background: #fff;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s ease-in-out;
  }
}
</style>
